import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Field} from '@app/interfaces';
import {croatianLocationLabel} from '@app/shared/briefd-form/field-types/bolha-location-labels';
import Papa from 'papaparse';

@Component({
    selector: 'app-form-input-bolha-location',
    templateUrl: './form-input-bolha-location.component.html',
    styleUrls: ['./form-input-bolha-location.component.scss'],
    standalone: false
})
export class FormInputBolhaLocationComponent implements OnInit {
    @Input() field: Field<string>;
    @Input() control: FormControl;

    regions: string[] = [];
    cities: string[] = [];
    places: { id: string, place: string }[] = [];

    selectedRegion: string = '';
    selectedCity: string = '';
    selectedPlace: string = '';

    private data: { id: string; region: string; city: string; place: string }[] = [];
    public isLoading = true;

    constructor(private cdr: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.loadCsvData();
    }

    displayName(name: string): string {
        return croatianLocationLabel(name);
    }

    setInitialValues(): void {
        const matchingData = this.data.find(item => item.id === this.field.value);
        if (matchingData) {
            this.selectedRegion = matchingData.region;
            this.selectedCity = matchingData.city;
            this.selectedPlace = matchingData.id;
            this.cities = Array.from(new Set(this.data.filter(item => item.region === this.selectedRegion).map(item => item.city))).sort();
            this.places = this.data.filter(item => item.region === this.selectedRegion && item.city === this.selectedCity).sort();
            this.updateControlValue();
        }
    }

    loadCsvData(): void {
        const csvFilePath = 'assets/csv/bolha-location.csv';
        fetch(csvFilePath)
            .then(response => response.text())
            .then(csvData => {
                Papa.parse(csvData, {
                    header: true,
                    skipEmptyLines: true,
                    delimiter: ';',
                    newLine: ';;\r\n',
                    complete: (result) => {
                        this.data = result.data as { id: string; region: string; city: string; place: string }[];
                        this.populateRegions();
                        if (this.field.value) {
                            this.setInitialValues(); // Ensure values are set after data is loaded
                        }
                    },
                    onerror: (error) => {
                        console.error('Error parsing CSV data:', error);
                    }
                });
            })
            .catch(error => {
                console.error('Error fetching CSV file:', error);
            });
    }

    populateRegions(): void {
        this.regions = Array.from(new Set(this.data.map(item => item['region']))).sort();
        this.cdr.detectChanges();
    }

    onRegionChange(event: Event): void {
        const region = (event.target as HTMLSelectElement).value;
        this.selectedRegion = region;
        this.cities = Array.from(new Set(this.data.filter(item => item.region === region).map(item => item.city))).sort();
        this.places = []; // Reset places when region changes
        this.selectedCity = '';
        this.selectedPlace = null;
        this.updateControlValue();
    }

    onCityChange(event: Event): void {
        const city = (event.target as HTMLSelectElement).value;
        this.selectedCity = city;
        this.places = this.data.filter(item => item.region === this.selectedRegion && item.city === city).sort();
        this.selectedPlace = null;
        this.updateControlValue();
    }

    updateControlValue(): void {
        this.control.setValue(this.selectedPlace);
        this.cdr.detectChanges();
    }
}
